import { State } from "../../../interfaces";
import {
  ActionTypes,
  TOGGLE_BLOCK_USER,
  TOGGLE_BLOCK_USER_CONSENT,
  TOGGLE_BLOCK_USER_ERROR,
  TOGGLE_BLOCK_USER_SUCCESS,
} from "./actionTypes";

export class UserState {
  toggleBlockUser!: State<any>;
  constructor() {
    this.toggleBlockUser = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: UserState = new UserState();

export const user = (state: UserState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case TOGGLE_BLOCK_USER_CONSENT:
      state = {
        ...state,
        toggleBlockUser: {
          ...state.toggleBlockUser,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_BLOCK_USER:
      state = {
        ...state,
        toggleBlockUser: {
          ...state.toggleBlockUser,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_BLOCK_USER_SUCCESS:
      state = {
        ...state,
        toggleBlockUser: {
          ...state.toggleBlockUser,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case TOGGLE_BLOCK_USER_ERROR:
      state = {
        ...state,
        toggleBlockUser: {
          ...state.toggleBlockUser,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};
